export const LOADER_ESTADOS         =       'LOADER_ESTADOS';
export const GET_ESTADOS            =       'GET_ESTADOS';
export const ESTADOS_FALLA          =       'ESTADOS_FALLA';
export const SAVE_LOADER_ESTADOS    =       'SAVE_LOADER_ESTADOS';
export const FORM_ESTADOS_FAIL      =       'FORM_ESTADOS_FAIL';

